import { keyframes } from '@emotion/react';
import { Box } from '@mui/joy';
import { FC } from 'react';

const BLUE = '#5FC2F0';

const ring = keyframes`
  0% { transform: scale(0.72); opacity: 0; }
  18% { opacity: 0.5; }
  100% { transform: scale(1.38); opacity: 0; }
`;
const breathe = keyframes`
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.06); opacity: 0.92; }
`;

/**
 * MINDD 호흡 링 — 진입 스플래시(MHomeSplash)와 재택 트리 로딩 인디케이터(MHomeLoading)가 공유한다.
 * 바깥 두 링이 반 주기 엇갈려 퍼지고, 코어는 같은 주기로 호흡한다.
 */
const MHomeRing: FC = () => (
  <Box
    sx={{ position: 'relative', width: 132, height: 132, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        borderRadius: '50%',
        border: `1px solid ${BLUE}`,
        animation: `${ring} 3.2s cubic-bezier(.22,.61,.36,1) infinite`,
      }}
    />
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        borderRadius: '50%',
        border: `1px solid ${BLUE}`,
        animation: `${ring} 3.2s cubic-bezier(.22,.61,.36,1) infinite 1.6s`,
      }}
    />
    <Box
      sx={{
        width: 76,
        height: 76,
        borderRadius: '50%',
        bgcolor: BLUE,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 12px 30px -10px rgba(95,194,240,0.5)',
        animation: `${breathe} 3.2s ease-in-out infinite`,
      }}>
      <Box sx={{ width: 26, height: 26, borderRadius: '50%', bgcolor: '#fff' }} />
    </Box>
  </Box>
);

export default MHomeRing;
